(ns rothko.editor.toolbar.component
  (:require [clojure.string :as string]
            [goog.string :as gstring]
            [rothko.button.component :as button-component :refer [button]]
            [rothko.dom.event :as event]
            [rothko.editor.actions :as actions]
            [rothko.icon.component :refer [icon]]
            [rothko.layout.component :refer [layout]]
            [rothko.tooltip.component :as tooltip]))

(def separator button-component/separator)

(defn toolbar-item
  [{:keys [:appearance ::name ::representation]
    icon-name ::icon
    :as props}]
  (let [name (when name
               (gstring/unescapeEntities
                (string/replace name #" " "&nbsp;")))]
    [:div.annotator__toolbar-item
     {:class appearance}
     [tooltip/tooltip
      {:appearance #{:plain-black :centered-triangle}
       ::tooltip/label name}
      [button props
       (cond
         icon-name [icon {:icon icon-name
                          :size 15}]
         representation representation
         :else name)]]]))

(defn action-on-click
  [!state button effect-fn event]
  (event/stop event)
  (swap! !state assoc :view :annotated)
  (swap! !state update :render not)
  (let [{:keys [implementation]} @!state
        action (-> (actions/button button)
                   (assoc ::actions/implementation implementation))
        action-with-fn (cond-> action
                         effect-fn
                         (assoc ::actions/effect-fn effect-fn))]
    (actions/enqueue-transformation!
      (actions/->transformation
        action-with-fn))
    (actions/log-action! action)))

(defn action-button
  [{:keys [:appearance ::action ::effect-fn ::!state] :as props}]
  [toolbar-item
   (assoc props
          :on-click #(action-on-click !state action effect-fn %)
          ;; TODO rothko#258
          :appearance (cond-> #{:secondary :no-outline :small}
                        (contains? appearance :warning) (disj :secondary)
                        appearance (clojure.set/union appearance)))])

(defn view-button
  [{:keys [::name ::!state ::view-state] :as props}]
  (let [view (:view @!state)]
    [toolbar-item
     {:appearance (cond-> #{:small :secondary} (not= view view-state) (conj :no-outline))
      :disabled? (not (:ro-view-hidden @!state))
      :on-click #(do (swap! !state assoc :view view-state)
                     (actions/log-action! (actions/button view-state)))
      ::name name}]))

(defn- toggle-ro-view-button-toggle-view
  "Handle a click event on the read-only view toggle button; either:
   - Make the read-only view visible and select the annotated view.
   - Hide the read-oly view."
  [!state]
  (let [ro-view-hidden (swap! !state assoc :ro-view-hidden (not (:ro-view-hidden @!state)))]
    (when (not (:ro-view-hidden ro-view-hidden))
      (swap! !state assoc :view :annotated))
    (actions/log-action! (actions/button ro-view-hidden))))

(defn toggle-ro-view-button
  "The read-only view toggle button."
  [{:keys [::name ::!state]}]
  [toolbar-item
   {:appearance (cond-> #{:small :secondary} (:ro-view-hidden @!state) (conj :no-outline))
    :on-click #(toggle-ro-view-button-toggle-view !state)
    ::name name}])

(defn ro-view-button
  "A button in the read-only view's toolbar."
  [{:keys [::name ::!state ::view-state]}]
  (let [view (:ro-view @!state)]
    [toolbar-item
     {:appearance (cond-> #{:small :secondary} (not= view view-state) (conj :no-outline))
      :on-click #(do (swap! !state assoc :ro-view view-state)
                     (actions/log-action! (actions/button view-state)))
      ::name name}]))

;; End.

(defn create-component
  [{:keys [::component] :as props}]
  [component props])

(defn toolbar
  [{:keys [!state appearance ::config]}]
  [layout {:appearance ((fnil conj #{}) appearance :column)
           :class [:editor__toolbar]}
   (into [layout {:appearance #{:horizontal :shrink}}]
         (comp (map #(assoc % ::!state !state))
               (map create-component))
         config)])
